import store from "@/store";
import analytics from "./analytics";
import auth from "./auth";
import companies from "./companies";
import groups from "./groups";
import members from "./members";
import monthlydata from "./monthlynumbers"
// import logs from "./logs";

export default [
  {
    path: "/",
    name: "home",
    redirect: "/manage/companies",
    component: () => import("@/views/layout/default"),
    children: [
      ...companies,
      ...groups,
      ...members,
      ...analytics,
      ...monthlydata,
      // ...logs
    ],
    beforeEnter(to, from, next) {
      if (store.getters.authenticated) next();
      else next({ name: "login", query: { next: to.path } });
    },
  },
  {
    path: "/",
    component: () => import("@/views/pages/auth/auth"),
    children: [...auth],
  },
  {
    path: "*",
    redirect: "/404",
  },
  {
    path: "/403",
    name: "403",
    meta: {
      title: "403",
    },
    component: () => import("@/views/pages/errors/403.vue"),
  },
  {
    path: "/404",
    name: "404",
    meta: {
      title: "404",
    },
    component: () => import("@/views/pages/errors/404.vue"),
  },
];
